import { render } from "./diabetes_imaging.vue?vue&type=template&id=1ca21a24&scoped=true"
import script from "./diabetes_imaging.vue?vue&type=script&lang=js"
export * from "./diabetes_imaging.vue?vue&type=script&lang=js"

import "./diabetes_imaging.vue?vue&type=style&index=0&id=1ca21a24&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca21a24"]])

export default __exports__